import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { PopupOpenMode, PopupViewMode } from 'src/app/common/enums/enums';
import { PopupOptions } from 'src/app/common/helpers/menulist/popup-options';
import { ParentCommunicatorService } from 'src/app/services/parent-communicator.service';
import { SourceListComponent } from './source-list/source-list.component';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NotifierV2Service } from 'src/app/services/notifier-v2.service';

@Component({
  selector: 'app-source-new',
  templateUrl: './source-new.component.html',
  styleUrls: ['./source-new.component.scss']
})
export class SourceNewComponent implements OnInit {
  @ViewChild('sourceListRef') sourceListRef: SourceListComponent;

  public data: any = {
    editSourceId: 0
  };

  private sub: Subscription;
  highlightedSourceId: number | null = null;

  constructor(private notifierService: NotifierV2Service) {
  }

  ngOnInit(): void {

    this.sub = this.notifierService.sourceChanged$.subscribe(sourceId => {
      this.data.editSourceId = sourceId;
      this.reloadEditor(sourceId);
    });

    const state = history.state as { sourceId?: number };
    if (state?.sourceId) {
      this.highlightedSourceId = null;

      setTimeout(() => {
        this.highlightedSourceId = state.sourceId;
      }, 0);
    }
    this.data.editSourceId = state.sourceId;
  }

  onSourceListCompleted(eventData: any) {
    if (eventData) {
      this.data = { ...this.data, ...eventData };
    }
  }

  onSourceEditorCompleted(eventData: any) {
    this.sourceListRef.getSourceList();
    this.highlightedSourceId = null;
    setTimeout(() => {
      this.highlightedSourceId = eventData.data.id;
    }, 0);
    this.data.editSourceId = 0;
  }

  private reloadEditor(sourceId: number) {
    const newEvent = {
      editSourceId: sourceId,
    };
    if (sourceId) {
      this.data = { ...this.data, ...newEvent };
      this.highlightedSourceId = null;

      setTimeout(() => {
        this.highlightedSourceId = sourceId;
      }, 0);
    }
  }
}
